module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box game",
    class: _vm.outcomeClass
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__outcome"
  }, [_c('div', [_vm._v(_vm._s(_vm.outcome))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__league-points"
  }, [_c('div', [_vm._v(_vm._s(_vm.leaguePosition.league_points) + " LP "), _c('span', {
    staticClass: "game__league-points-change"
  }, [_vm._v(_vm._s(_vm.change))])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__rank"
  }, [_c('div', [_vm._v(_vm._s(_vm.rank))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__date"
  }, [_c('div', [_vm._v(_vm._s(_vm.trackedAt))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__score"
  }, [_c('div', {
    staticClass: "score__title"
  }, [_vm._v("Score")]), _vm._v(" "), _c('div', {
    staticClass: "score__value"
  }, [_vm._v(_vm._s(_vm.leaguePosition.score))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2a84812","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeaguePosition.vue
// module id = 409
// module chunks = 1